import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import PageHeader from '../../Components/Learn/PageHeader';
import { romanToInt } from '../../Util/data';
import StartupToolsCard from '../../Components/Learn/StartupToolsCard';
const LearnSubPage = ({ pageTitle, pageShortTitle, pageLink, articles }) => {
    const { t } = useTranslation();
    const [sortedArticles, setSortedArticles] = useState([]);
    useEffect(() => {
        const sorted = articles.sort((a, b) => {
            const romanA = a.title.split('.')[0].trim();
            const romanB = b.title.split('.')[0].trim();
            return romanToInt(romanA) - romanToInt(romanB);
        });
        setSortedArticles(sorted);
    }, []);
    return (React.createElement("div", { className: "w-full bg-gray-50" },
        React.createElement(PageHeader, { title: pageTitle, shortTitle: pageShortTitle, hasLink: true, link: pageLink }),
        React.createElement("section", { className: "py-16 w-full px-6" },
            React.createElement("div", { className: "w-full max-w-(--breakpoint-2xl) mx-auto grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-8" }, sortedArticles.length ? (sortedArticles.map((article, index) => {
                return (React.createElement(StartupToolsCard, Object.assign({ key: article.id }, article, { index: index + 1, type: "subcategory" })));
            })) : (React.createElement("h2", { className: "text-gray-800 text-xl font-semibold" }, t('learn.subsection.noArticles')))))));
};
export default LearnSubPage;
